module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-16.jpg?v=2f8e5233";